"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTokensInTemplate = getTokensInTemplate;
exports.templateIterator = templateIterator;
exports.templateResolver = templateResolver;
exports.tokenSuffix = exports.tokenPrefix = void 0;
var _lodash = require("@avantia/lodash");
var _loggingAndErrors = require("@avantia/logging-and-errors");
var _logging = require("./logging");
const tokenPrefix = '{{';
exports.tokenPrefix = tokenPrefix;
const tokenSuffix = '}}';
exports.tokenSuffix = tokenSuffix;
const tokenPrefixLen = tokenPrefix.length;
const tokenSuffixLen = tokenSuffix.length;
function templateResolver(template, model) {
  return templateIterator(template, name => {
    const value = (0, _loggingAndErrors.hasOwnProperty)(model, name) ? model[name] : `[${name}]`;
    return typeof value === 'function' ? value() : value;
  });
}
function getTokensInTemplate(template) {
  const tokens = {};
  templateIterator(template, name => {
    tokens[name] = true;
    return '';
  });
  return _lodash.lodash.keys(tokens).sort();
}
function templateIterator(template, resolver) {
  if (!template) {
    return '';
  }
  let tmp = template;
  let startAt = 0;
  while (startAt >= 0) {
    startAt = tmp.indexOf(tokenPrefix, startAt);
    const endAt = tmp.indexOf(tokenSuffix, startAt + tokenPrefixLen);
    if (startAt >= 0 && endAt >= startAt) {
      const name = tmp.slice(startAt + tokenPrefixLen, endAt);
      const value = '' + resolver(name);
      tmp = tmp.slice(0, startAt) + value + tmp.slice(endAt + tokenSuffixLen);
      startAt += value.length;
    } else {
      break;
    }
  }
  if (startAt >= 0 || tmp.indexOf(tokenSuffix) >= 0) {
    (0, _logging.logError)(`Found unresolved template artifacts in "${template}": "${tmp}"`);
  }
  return tmp;
}